/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeatureWebpageComponentDisplay } from "cms/components/components/feature-webpage/display";
import { FeatureWebpageComponentEditor } from "cms/components/components/feature-webpage/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const FeatureWebpageComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <FeatureWebpageComponentDisplay />,
        editComponent: <FeatureWebpageComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

FeatureWebpageComponent.displayName = "FeatureWebpageComponent";
export { FeatureWebpageComponent };
